// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1w-Pn","selected":"Chip_selected__2ngiR"};